document.addEventListener("DOMContentLoaded", () => {
    const campusCheckboxes = document.querySelectorAll('input[name="campus"]');
    const typeCheckboxes = document.querySelectorAll('input[name="category"]');
    const resetButton = document.querySelector('.btn-reset');

    const events = Array.from(
        document.querySelectorAll('.inwink-column')
    );

    function filterEvents() {

        const selectedCampus = Array.from(campusCheckboxes)
            .filter(input => input.checked)
            .map(input => input.value.toLowerCase());

        const selectedTypes = Array.from(typeCheckboxes)
            .filter(input => input.checked)
            .map(input => input.value.toLowerCase());

        const noFilter =
            selectedCampus.length === 0 &&
            selectedTypes.length === 0;

        const maxEvents = window.innerWidth <= 768 ? 3 : 11;

        let filteredEvents = events.filter(event => {

            const eventCampus = event.dataset.campus.toLowerCase();
            const eventType = event.dataset.type.toLowerCase();

            const matchCampus =
                selectedCampus.length === 0 ||
                selectedCampus.includes(eventCampus);

            const matchType =
                selectedTypes.length === 0 ||
                selectedTypes.includes(eventType);

            return matchCampus && matchType;
        });

        filteredEvents.sort((a, b) => {

            const dateA = new Date(a.dataset.date);
            const dateB = new Date(b.dataset.date);

            return dateA - dateB;
        });

        if (noFilter) {

            const campusMap = new Map();

            filteredEvents.forEach(event => {

                const campus = event.dataset.campus;

                if (!campusMap.has(campus)) {
                    campusMap.set(campus, event);
                }
            });

            filteredEvents = Array.from(campusMap.values());

            filteredEvents.sort((a, b) => {

                const dateA = new Date(a.dataset.date);
                const dateB = new Date(b.dataset.date);

                return dateA - dateB;
            });
        }

        events.forEach(event => {
            event.style.display = "none";
        });

        filteredEvents.slice(0, maxEvents).forEach(event => {
            event.style.display = "flex";
        });

        const parent = events[0]?.parentNode;

        if (parent) {
            filteredEvents.forEach(event => {
                parent.appendChild(event);
            });
        }
    }

    campusCheckboxes.forEach(input => {
        input.addEventListener("change", filterEvents);
    });

    typeCheckboxes.forEach(input => {
        input.addEventListener("change", filterEvents);
    });

    if (resetButton) {

        resetButton.addEventListener("click", (e) => {

            e.preventDefault();

            campusCheckboxes.forEach(input => {
                input.checked = false;
            });

            typeCheckboxes.forEach(input => {
                input.checked = false;
            });

            filterEvents();
        });
    }

    window.addEventListener("resize", filterEvents);

    filterEvents();

});